/**
 * Created by jacky on 2/26/16.
 * @flow
 * @providesModule App
 */
import React, { Component } from "react";
import Task from "../Task/task";
import Transition from "../Transition/transition";
import {CasualLink} from "../../lib/link";
import {AxisGrid} from "../../lib/Axis";
import Armap from "../../lib/armap";
import _ from "../../constants";
import type {
    TaskInfoType,
    TransitionInfoType
} from "../../lib/stories-shared";
import {
    isBetween,
    getTranslate,
    getTopOffset,
    GBBox,
    processSlides, showImage, isElementPartiallyInViewport, atoi, getEl, getClientRect, getEls, getHTMLData, addClass,
    removeClass, toggleClass, getStyle, checkBoundries, getScale, isElementIsChildOf
} from "../../lib/stories-shared";
import {findDOMNode} from "react-dom";
import im from "include-media-export/include-media";
import $ from 'jquery';
import d3 from 'd3';

require("./app.scss");

import {DIALOG} from "../Dialogs/dialogs";
import {throttle, isMobileBrowser} from "../../lib/utils";
import { GA, MP } from '../../lib/analytics';

declare var contentPool;
declare var contentId;

type AppPropsType = {
    tasks: Armap<string, TaskInfoType>,
    transitions: Armap<string, TransitionInfoType>,
    dialogInterface: (p: number, data?:any) => void
}

type THeaderCoordinates = {
    id: string;
    el: HTMLElement;
}

type AppStateType = {
    x: number;
    y: number;
    z: number;
}

const setActiveElement = (el: Element) => {
    $(el).parent().find('.clsActive').removeClass('clsActive');
    $(el).addClass('clsActive');
};

const preventDefault = (ev) => ev.preventDefault();
let tutorialShown = !!localStorage.getItem(_.gcTutorialWorkflowPopupKey);
let $tutorialPopup = $(`
<div class="clsTutorial">
    <div>For the best experience,<br />view on desktop</div>
</div>
`);

class App extends Component {
    props: AppPropsType;
    state: AppStateType;

    _axis: AxisGrid;
    _targetId: string;
    _oy: number;
    _canvas: SVGElement;
    _leftOffset: number;
    _canvasWidth: number;
    _canvasHeight: number;
    _isFixed: boolean;
    _treeOffsetCor: number;
    _zoomNPan;
    _topOffset: number;
    _treeTop: number;
    _view_node: SVGElement;
    _isProcessView: boolean;
    _skipCheckScroll: boolean;
    _container;
    _coords: Armap<string, THeaderCoordinates>;
    _headerHeight: number = 67;
    _delta: number = 0;
    _staPopup;


    constructor(props: AppPropsType) {
        super(props);

        this._axis = new AxisGrid(0, 0, _.trINIT_COL, _.trINIT_ROW, _.trCOL_WIDTH, _.trROW_HEIGHT, 1000, 1000, _.trCOL_INC, _.trROW_INC);
        this.props.tasks.asArray().forEach((d: TaskInfoType) => this._axis.add(atoi(d.rowId), atoi(d.colId), false));
        this._axis.update(true);

        this._zoomNPan = d3.behavior.zoom().scaleExtent([0.2, 1])
            .on('zoom', () => {
                let {translate: [dx, dy], scale: sc}  = d3.event;

                if (!this._staPopup && this._isProcessView) {
                    this._staPopup = this.showSTAPopup(true);
                }

                const v = GBBox(this._view_node);
                const vp = {
                    ...v,
                    height: this._staPopup && this._isProcessView ? v.height + getClientRect(this._staPopup).height : v.height
                }

                if (this._isProcessView) {
                    let {x, y} = checkBoundries({x: dx, y: dy}, vp, getClientRect('.clsStory-canvas'), sc);
                    dx = x;
                    dy = y;
                }

                this._zoomNPan.translate([dx, dy]);
                this._zoomNPan.scale(sc);
                d3.select(this._view_node).attr('transform', `translate(${dx}, ${dy}) scale(${sc})`);
                // d3.event.sourceEvent && d3.event.sourceEvent.preventDefault();
                if ($tutorialPopup && !$tutorialPopup.CR) {
                    setTimeout(() => {
                        $tutorialPopup &&
                            $tutorialPopup.fadeOut(() =>
                                $tutorialPopup && $tutorialPopup.remove(), $tutorialPopup = null
                            )
                    }, 2000);
                    $tutorialPopup.CR = true;
                }

                return true;
            });
    }

    _positionCanvas(id?: string, y: number = 0, initial: boolean = false, animate: boolean = false, scale: number = 0, shouldICenter: boolean = false) {
        if (id == this._targetId) {
            return
        }

        if (!id) {
            if (!this._targetId) { return }
            id = this._targetId;
            y = this._oy;
        } else {
            this._oy = y;
        }

        const view = d3.select(this._view_node);
        const cp = getTranslate(this._view_node);
        const sc = scale || getScale(this._view_node);

        const task = this.props.tasks.byId(id);
        const task_node = findDOMNode(this.refs[task.id]);
        const c = getTranslate(task_node);

        let ty;
        let x;

        if (this._isFixed) {
            ty = -c[1] * sc + window.innerHeight * .20;
        } else {
            ty = y - c[1] * sc - this._treeOffsetCor;// - headerHeight
        }

        if (shouldICenter) {
            const v = GBBox(this._view_node);
            x = (this._canvasWidth - v.width) / 2;
            const vp = {
                ...v,
                height: this._staPopup ? v.height + getClientRect(this._staPopup).height : v.height
            }
            const tmp = checkBoundries({x, y: ty}, vp, getClientRect('.clsStory-canvas'), sc);
            x = tmp.x;
            ty = tmp.y;
        } else {
            if (!isBetween([c[0] * sc, c[0] * sc + _.trTaskWidth * sc], -cp[0] * sc + this._leftOffset, -cp[0] * sc + (this._canvasWidth - this._leftOffset)) || initial) {
                x = this._leftOffset + Math.round(-c[0] * sc + ((this._canvasWidth - this._leftOffset) - _.trTaskWidth * sc) / 2);
            }
        }

        this._targetId = id;
        if (animate !== false){
            view.interrupt()
                .transition()
                .attr('transform', `translate(${x || cp[0]}, ${ty}) scale(${sc})`)
                .ease();
        } else {
            view.attr('transform', `translate(${x || cp[0]}, ${ty}) scale(${sc})`);
        }

        this._zoomNPan.translate([(x || cp[0]), ty]);
        this._zoomNPan.scale(sc);

        // view.selectAll('g.clsTask.clsActive').classed('clsActive', false);
        // d3.select(task_node).classed('clsActive', true);
    }

    componentDidMount() {
        const win = window;
        const asc = getEl('article.clsStoryContent');
        const isMobile = !im.greaterThan('mobile');

        this._container = getEl('#clsStory-tree');
        this._leftOffset = asc.offsetLeft + asc.offsetWidth;
        this._topOffset = getTopOffset(asc);
        this._treeTop = getClientRect('div.clsStory-cover').height;
        this._treeOffsetCor = this._treeTop - this._topOffset;
        this._view_node = findDOMNode(this.refs['view']);
        this._canvas = findDOMNode(this.refs['canvas']);

        const ors = () => {
            const {width, height} = getClientRect(this._canvas);
            this._canvasWidth = width;
            this._canvasHeight = height;
            this._positionCanvas();
        };

        $(win).on({'resize': throttle(ors, 50)});
        ors();

        const $headers = getEls('section.clsStory-section');

        this._coords = Armap.fromArray('id', $headers.map(v => {
            return {
                id: getHTMLData(v, 'task-id'),
                el: v
            }
        }));

        const i = this._coords[0];
        this._positionCanvas(i.id, i.el.offsetTop, true, false, im.getActive() == 'mobile' ? 0.7 : 1);
        this._markTasks(i.id);
        MP('ST Visit', `${contentPool}/${contentId}`);

        let vector: boolean;
        let ov: number = 0;
        let actualId: string;

        const checkScroll = throttle(() => {
            if (this._skipCheckScroll === true) { return }
            const y = win.scrollY;
            const windowHeight = (window.innerHeight || document.documentElement.clientHeight);

            vector = ov - y < 0;
            ov = y;
            const items = this._coords.asArray().map(p => {
                const { id, el } = p;
                const { top, bottom, height } = getClientRect(el);
                const visible = (top <= windowHeight) && ((top + height) >= 0);
                const edge = vector ? top < (windowHeight * .3) : bottom > (windowHeight * .3);
                return {
                    id,
                    el,
                    top,
                    bottom,
                    visible,
                    edge
                }
            }).filter(p => p.visible && p.edge);
            if (items.length) {
                let p = items.length > 1 && vector
                    ? (items[0].top < 0 ? items[1] : items[0])
                    : items[0];
                if (p.id != this._targetId) {
                    this._positionCanvas(p.id, p.top, false, true);
                    this._markTasks(this._targetId = p.id);
                }
            }
        }, 50);
        const _footer = getEl('.clsStory footer');

        getEls('.clsStoryContent a').forEach(e => {
            e.setAttribute('target', '_blank')
            // e.setAttribute('rel', 'noopener');
        });

        const watchPopup = () => {
            console.log('watchPopup');
            ['click','wheel','touchstart'].forEach(e => {
                document.addEventListener(e, dismissPopup, true);
            })
        }
        const TOCContainer = getEl('.clsTOCContainer');
        const dismissPopup = (ev) => {
            console.log('dismissPopup');
            !(ev.type == 'touchstart' && isElementIsChildOf((ev.target: any), getEl('.clsHeaderTOCIcon')))
                &&
                !isElementIsChildOf((ev.target: any), TOCContainer)
                && (console.log('dismissPopup::fake-click'),$('.clsTOCHandler').click());
            ['click','wheel','touchstart'].forEach(e => {
                document.removeEventListener(e, dismissPopup, true);
            })
        }

        let oy = win.scrollY;
        $(document)
            .on('scroll', (ev) => {
                const isFV = isElementPartiallyInViewport(_footer);
                if (!isFV && win.scrollY + this._headerHeight > this._treeTop) {
                    if (!this._isFixed) {
                        addClass(this._container, 'clsFixed');
                        this._isFixed = true;
                    }
                    removeClass([this._container, '.clsSocialContainer', '.clsTOCContainer'], 'clsView4Footer');
                } else {
                    if (this._isFixed) {
                        removeClass(this._container, 'clsFixed');
                        this._isFixed = false;
                    }
                    if (isFV) {
                        addClass([this._container, '.clsSocialContainer', '.clsTOCContainer'], 'clsView4Footer');
                    }
                    // if (win.scrollY + this._headerHeight < this._treeTop) {
                    //     removeClass('.clsSocialContainer', 'clsFixed');
                    // }
                }

                this._delta = oy - win.scrollY;
                oy = win.scrollY;
                checkScroll();
            })
            .on('click', '.story-section h3', (ev) => {
                const id = getHTMLData(ev.target.parentNode, 'task-id');
                this._positionCanvas(id, this._coords.byId(id).el.offsetTop);
            })
            .on('click touchstart', '.clsHeaderShare', (ev) => {
                removeClass('.clsTOCContainer', 'clsShow');
                toggleClass('.clsSocialContainer', 'clsActive');
                if (!this._staPopup && isMobile) {
                    this.showSTAPopup(true);
                }
                return false;
            })
            .on('click', '.clsHeaderControlButton-story', (ev) => {
                $('.clsTutorial').remove();
                GA({category: 'Content', action: 'ViewStory'});
                // $('.clsStory-canvas').on('touchmove', preventDefault);
                getEl('.clsStory-canvas').addEventListener('touchmove', preventDefault);
                this._leftOffset = asc.offsetLeft + asc.offsetWidth;
                getStyle('body').overflow = 'initial';
                getStyle('footer').display =  '';
                if (this._staPopup) {
                    this.showSTAPopup(false);
                    // removeClass(this._staPopup, 'clsActive');
                    // this._staPopup = null;
                }
                removeClass(getEl('.clsStory-body'), 'clsInteractive');
                this._positionCanvas(undefined, undefined, true, true);
                this._isProcessView = false;
                setActiveElement(ev.target);
            })
            .on('click', '.clsHeaderControlButton-process', (ev) => {
                $('.clsTutorial').remove();
                GA({category: 'Content', action: 'ViewProcess'});
                // $('.clsStory-canvas').off('touchmove', preventDefault);
                getEl('.clsStory-canvas').removeEventListener('touchmove', preventDefault);
                this._leftOffset = 0;
                getStyle('body').overflow = 'hidden';
                addClass('.clsStory-body', 'clsInteractive');
                this._positionCanvas(undefined, undefined, true, true, im.greaterThan('mobile') ? 1 : 0.5, true);
                this._isProcessView = true;
                const cover = getEl('.clsStory-cover');
                if (isElementPartiallyInViewport(cover)) {
                    getEl('body').scrollTop = getClientRect(cover).height;
                }
                setActiveElement(ev.target);
                if (!tutorialShown && isMobileBrowser && $tutorialPopup) {
                    localStorage.setItem(_.gcTutorialWorkflowPopupKey, '1')
                    $tutorialPopup.appendTo('body').on('click', () => {
                        $('.clsTutorial').fadeOut(() => {
                            $('.clsTutorial').remove();
                            $tutorialPopup = null;
                        });
                    })
                }
            })
            .on('click', 'figure.attachment', (ev) => {
                const el = ev.currentTarget;
                const {contentType, url} = getHTMLData(el, 'trix-attachment');

                switch (contentType) {
                    case 'image':
                        // showImage(url, $(this).find('img').get(0) as HTMLImageElement);
                        this.props.dialogInterface(DIALOG.imageViewer, getEl('img', el));
                        break;
                }
            })
            .on('click', 'aside .clsCrossIcon, .clsGetStarted-noButton', (ev) => {
                GA({category: 'Acquire', action: 'CloseCTA', value: 'LeftBar'});
                localStorage.setItem(_.gcSTAKey, '1');
                this._staPopup = null;
                this.showSTAPopup(false);
            })
            .on('click', '.clsGetStarted', (ev) => {
                this.props.dialogInterface(DIALOG.SignUp);
                return false;
            })
            .on('click', '.clsSection-images', (ev) => {
                this.props.dialogInterface(DIALOG.imageViewer, getEls('img', ev.currentTarget));
            })
            .on('click touchstart', '.clsHeaderTOCIcon, .clsTOC .clsCrossIcon, .clsTOCHandler', (ev) => {
                if (isMobileBrowser && ev.type == 'click') { return true }
                removeClass('.clsSocialContainer', 'clsActive');
                const p = toggleClass('.clsTOCContainer', 'clsShow');
                p && watchPopup();
                GA({category: 'Content', action: p ? 'ViewTOC' : 'CloseTOC'});
                isMobile && (getStyle('.clsTOCContainer').transform = `translateY(${p ? getClientRect('.clsTOCContainer').height + 40 : 0}px)`);
                if (!this._staPopup && isMobile) {
                    this.showSTAPopup(true);
                }
                return false;
            });

        const el = d3.select(this._canvas);

        el.call(this._zoomNPan);

        el.on('dblclick.zoom', null);

        el.on('wheel.zoom', null);
        el.on('mousewheel.zoom', null);
        el.on('MozMousePixelScroll.zoom', null);

        // FIXME: remove jquery
        $('svg').on('wheel', (ev) => {
            if (!this._isProcessView) { return true }

            if (!this._staPopup) {
                this._staPopup = this.showSTAPopup(true);
            }

            const oev = ev.originalEvent;
            const c = getTranslate(this._view_node);
            const sc = getScale(this._view_node);
            const p = oev['deltaMode'] ? 60 : 1;

            const v = GBBox(this._view_node);
            const vp = {
                ...v,
                height: this._staPopup && this._isProcessView ? v.height + getClientRect(this._staPopup).height : v.height
            }

            let {x: dx, y: dy} = checkBoundries({x: c[0] + (-oev['deltaX'] * p), y: c[1] + (-oev['deltaY'] * p)}, vp, getClientRect('.clsStory-canvas'), sc);

            d3.select(this._view_node).attr('transform', `translate(${dx}, ${dy}) scale(${sc})`);
            this._zoomNPan.translate([dx, dy]);
            this._zoomNPan.scale(sc);
            ev.preventDefault();

            return false;
        });
    }

    _markTasks(id: string) {
        // if (hasClass(this._coords.byId(id).el, 'clsActive')) { return }
        let mark = false;

        this._coords.asArray().forEach(p => {
            const treeEl = findDOMNode(this.refs[p.id]);
            if (p.id == id) {
                addClass([p.el, treeEl], 'clsActive');
                removeClass(treeEl, 'clsDone');
                mark = true;
            } else if (mark) {
                removeClass(p.el, 'clsActive');
                removeClass(treeEl, 'clsActive clsDone');
            } else {
                removeClass(p.el, 'clsActive');
                removeClass(treeEl, 'clsActive');
                addClass(treeEl, 'clsDone');
            }
        })
    }

    _taskDblClick(d: TaskInfoType) {
        // FIXME: remove jquery
        const $el = $(this._coords.byId(d.id).el);
        const tc = $el.offset().top;
        this._markTasks(d.id);
        this._skipCheckScroll = true;
        this._targetId = d.id;
        GA({category: 'Content', action: 'NavigateStory', value: this._isProcessView ? 'FromProcess' : 'FromStory'});
        $('.clsHeaderControlButton-story').trigger('click');
        $('.clsStory-section').removeClass('clsActive');
        $el.addClass('clsActive');
        $('body, html').animate({scrollTop: tc - this._headerHeight - 40}, 250);
        setTimeout(() => { this._skipCheckScroll = false }, 400);
    }

    showSTAPopup(show: boolean): HTMLElement {
        const $popup = getEl('aside');
        if (show) {
            addClass($popup, 'clsActive');
        } else {
            removeClass($popup, 'clsActive');
        }
        this._staPopup = show ? $popup : null;
        return $popup;
    }

    render() {
        const tasksData = this.props.tasks;
        const linksData = this.props.transitions;

        const getXY = (id: string) => {
            const obj = tasksData.byId(id);
            return {x: this._axis.x.axisById(atoi(obj.colId)), y: this._axis.y.axisById(atoi(obj.rowId))}
        };

        const path = new CasualLink(d => getXY(d.fromId), d => getXY(d.toId), 0, false);
        path.useBoxDim(_.trTaskWidth, _.trTaskHeight);

        return (
            <svg className="clsStory-canvas" ref="canvas" width="100%" height="100%" version="1.1">
                <defs>
                    <marker id="clsArrow" viewBox="0 0 10 10" refX="8" refY="5" markerUnits="strokeWidth" orient="auto" markerWidth="6" markerHeight="5">
                        <polyline points="0,0 10,5 0,10 1,5"/>
                    </marker>
                </defs>
                <g className="clsView" ref="view">
                    <g>
                        {linksData.asArray().map(link => <Transition key={link.id} data={link} pathProcessor={path} />)}
                    </g>
                    <g>
                        {tasksData.asArray().map(
                            task => <Task
                                key={task.id}
                                ref={task.id}
                                task={task}
                                axis={getXY(task.id)}
                                width={_.trTaskWidth}
                                height={_.trTaskHeight}
                                onDblClick={this._taskDblClick.bind(this)}
                            />)}
                    </g>
                </g>
            </svg>
        )
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/app.jsx